var _excluded = ["size", "className", "children", "disabled", "data-qa", "inputProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import { joinCn } from "@ati/uti";
var RadioButton = _ref => {
  var {
      size = "medium",
      className,
      children = "radio-button",
      disabled,
      "data-qa": dataQa = "radio",
      inputProps
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("label", _extends({
    className: joinCn("glz-radio", "glz-is-".concat(size), className),
    "data-qa": dataQa
  }, props), /*#__PURE__*/React.createElement("input", _extends({
    className: "glz-radio-input",
    type: "radio",
    disabled: disabled
  }, inputProps)), /*#__PURE__*/React.createElement("span", {
    className: "glz-radio-label"
  }, children));
};
RadioButton.propTypes = {
  /** Внешние стили */
  className: PropTypes.string,
  /** Содержимое */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /** Задать размер компонента - small или medium */
  size: PropTypes.oneOf(["small", "medium"]),
  /** Заблокированное состояние */
  disabled: PropTypes.bool,
  /** Функция вызываемая при нажатии */
  onClick: PropTypes.func,
  /** Функция срабатывает сразу при выборе значения */
  onChange: PropTypes.func,
  /** Значение */
  value: PropTypes.string,
  /** data-qa атрибут для тестирования */
  "data-qa": PropTypes.string,
  /** Пропсы, которые будут прокинуты в input */
  inputProps: PropTypes.object
};
export default RadioButton;